import { Box, Text } from '@wix/design-system';
import React from 'react';
import { SaleBanner as PlatformSaleBanner } from '@wix/premium-purchase-platform/@components';
import {
  SaleBannerStrip,
  SaleTimer,
  useSaleBannerType,
  extractNumericRate,
} from '@wix/package-picker-shared-studio';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import s from './SaleBanner.scss';

export const SaleBanner = () => {
  const { bannerType, isLoading: isSaleBannerTypeLoading } =
    useSaleBannerType();
  const { Trans } = StudioPackagePickerModule.internals.useTranslations();

  return (
    <PlatformSaleBanner.Root>
      {({ data, isLoading: isSaleBannerLoading }) => {
        const { rate, timeLeft } = data ?? {};

        if (
          isSaleBannerTypeLoading ||
          isSaleBannerLoading ||
          !bannerType ||
          !rate
        ) {
          return null;
        }

        const numericRate = extractNumericRate(rate);

        if (bannerType === 'last_day' && timeLeft) {
          return (
            <SaleBannerStrip desktopHeight="55px">
              <Box
                align="center"
                verticalAlign="middle"
                width="100%"
                textAlign="center"
              >
                <Text size="small" className={s.saleBannerText}>
                  <Trans
                    i18nKey="premium-purchase-plan.studio_sale.last_day_countdown.header.strip"
                    values={{ percent: numericRate }}
                  />
                </Text>
                <Box className={s.divider} />
                <SaleTimer
                  hours={timeLeft.hours}
                  minutes={timeLeft.minutes}
                  seconds={timeLeft.seconds}
                />
              </Box>
            </SaleBannerStrip>
          );
        }

        const content = (
          <Text size="medium" className={s.saleBannerText}>
            <Trans
              i18nKey="premium-purchase-plan..studio_sale.limited_time.header.strip"
              values={{ percent: numericRate }}
              components={{ strong: <strong /> }}
            />
          </Text>
        );

        return <SaleBannerStrip>{content}</SaleBannerStrip>;
      }}
    </PlatformSaleBanner.Root>
  );
};
